import React from 'react';
import LicenseComponent from '../Component/LicenseComponent';

export default function LicenseContainer() {
  return <LicenseComponent />;
}
